<input type="text"
       class="form-control"
       [id]="id"
       [maskito]="maskitoOptions"
       [(ngModel)]="value"
       (ngModelChange)="onValueChange()"
       [disabled]="isDisabled"
       (blur)="onTouched($event)"
       [placeholder]="placeholder"
       autocomplete="off">
